import styled, { css } from 'styled-components';
import { LinkColor } from '../Link/Link.constants';
import { getOutlineStyles } from '../utils/accessibility';
import { createShouldForwardProp } from '../utils/createShouldForwardProp';
export const LinkBaseRoot = styled.a.withConfig({
  shouldForwardProp: createShouldForwardProp(['isFocusVisible'])
}).withConfig({
  componentId: "ds__sc-16wurt4-0"
})(["font-size:inherit;font-family:", ";text-decoration:none;text-decoration-color:red;color:", ";outline:none;cursor:pointer;", " &:hover,&:focus{color:", ";text-decoration:underline;}"], props => props.theme.fontFamilyPrimary, _ref => {
  let {
    theme: {
      Link
    },
    color
  } = _ref;
  return color !== undefined ? Link.LINK_COLOR_TO_COLOR[color] : Link.LINK_COLOR_TO_COLOR[LinkColor.SECONDARY_CONTRAST];
}, _ref2 => {
  let {
    isFocusVisible,
    theme
  } = _ref2;
  return isFocusVisible && css(["&:focus{", "}"], getOutlineStyles(theme.Main.outline.color));
}, _ref3 => {
  let {
    theme: {
      Link
    },
    color
  } = _ref3;
  return color !== undefined ? Link.LINK_COLOR_TO_HOVER_COLOR[color] : Link.LINK_COLOR_TO_HOVER_COLOR[LinkColor.SECONDARY_CONTRAST];
});